import { CircleAlert } from 'lucide-react';

/** Form-level error banner announced to assistive technology. */
export function FormProblem({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div
      role="alert"
      className="flex items-start gap-2 rounded-md border border-crit/30 bg-crit-soft px-3 py-2 text-[13px] text-crit"
    >
      <CircleAlert aria-hidden="true" className="mt-0.5 size-4 shrink-0" strokeWidth={2} />
      <span>{message}</span>
    </div>
  );
}
